import logoIconFilledUrl from '#src/images/logo-icon-filled.svg';
import logoIconOutlineUrl from '#src/images/logo-icon-outline.svg';
import logoWhiteUrl from '#src/images/logo-white.svg';
import logoUrl from '#src/images/logo.svg';

export function Logo({
  dark = false,
  full = true,
  outline = false
}: {
  dark?: boolean;
  full?: boolean;
  outline?: boolean;
}) {
  return (
    <div className="flex items-center gap-x-2 sm:gap-x-2.5">
      {outline ? (
        <img aria-hidden className="h-5 sm:h-6" src={logoIconOutlineUrl} />
      ) : (
        <img aria-hidden className="h-5 sm:h-6" src={logoIconFilledUrl} />
      )}
      {full && (
        <img
          aria-label="Slash How"
          className="h-3 w-auto sm:h-4"
          src={dark ? logoWhiteUrl : logoUrl}
        />
      )}
    </div>
  );
}
